var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBars)?_c('div',{staticClass:"c-book-title"},[(_vm.responsive === 'desktop' && !_vm.connection)?_c('div',{staticClass:"c-book-title__badge"},[_c('offline-badge',{attrs:{"color":'grey'}})],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }